import React from "react";
import { useNavigate } from "react-router-dom";

const AboutLeftTabs = () => {
  const navigate = useNavigate();
  return (
    <div className="about-left-tabs">
      <i
        class="fa-solid fa-house op-04"
        onClick={() => {
          navigate("/");
        }}
      ></i>

      <i
        onClick={() => {
          navigate("/about");
        }}
        class="fa-solid fa-magnifying-glass"
      ></i>

      <i
        onClick={() => {
          navigate("/projects");
        }}
        class="fa-solid fa-folder-open op-04"
      ></i>
      <i
        onClick={() => {
          navigate("/terminal");
        }}
        class="fa-solid fa-code"
      ></i>

      <i
        onClick={() => {
          navigate("/ai-chat");
        }}
        class="fa-solid fa-robot"
      ></i>
      <i class="fa-solid fa-boxes-packing no-hover"></i>
    </div>
  );
};

export default AboutLeftTabs;
